(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flagship-layer-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initLayerCards(root) {
      root.querySelectorAll('[data-lc-stage]').forEach(function (stage) {
        if (stage.dataset.lcBound) return;
        stage.dataset.lcBound = '1';
        var section = stage.closest('.flagship-layer-cards');
        var dataEl = section && section.querySelector('[data-lc-data]');
        var layers = [];
        try {
          layers = JSON.parse(dataEl.textContent);
        } catch (e) {
          return;
        }
        if (!layers.length) return;
        // Warm the other layers AFTER load, at idle — an eager loop here
        // fetched every card at init and competed with the hero LCP (9.2).
        var warm = function () {
          // Desktop hides the stage (grid instead) — nothing to warm there.
          if (stage.offsetParent === null) return;
          layers.forEach(function (L) {
            if (!L.img) return;
            var im = new Image();
            im.sizes = '100vw';
            if (L.srcset) im.srcset = L.srcset;
            im.src = L.img;
          });
        };
        var atIdle = function () {
          if (window.requestIdleCallback) {
            window.requestIdleCallback(warm, { timeout: 3000 });
          } else {
            setTimeout(warm, 1500);
          }
        };
        if (document.readyState === 'complete') atIdle();
        else window.addEventListener('load', atIdle, { once: true });
        var img = stage.querySelector('[data-lc-img]');
        var eye = stage.querySelector('[data-lc-eyebrow]');
        var title = stage.querySelector('[data-lc-title]');
        var body = stage.querySelector('[data-lc-body]');

        function show(i) {
          i = ((i % layers.length) + layers.length) % layers.length;
          stage.dataset.lcI = i;
          var L = layers[i];
          if (img && L.img) {
            // srcset must track src — a stale srcset wins over a swapped src.
            img.srcset = L.srcset || '';
            img.src = L.img;
            img.alt = L.title || '';
          }
          if (eye) eye.textContent = L.eyebrow || '';
          if (title) title.textContent = L.title || '';
          if (body) body.textContent = L.body || '';
          stage.querySelectorAll('[data-lc-fade]').forEach(function (el) {
            el.classList.remove('lc-fade');
            void el.offsetWidth;
            el.classList.add('lc-fade');
          });
        }

        stage.addEventListener('click', function (e) {
          if (e.target.closest('[data-lc-prev]')) show(+stage.dataset.lcI - 1);
          else if (e.target.closest('[data-lc-next]')) show(+stage.dataset.lcI + 1);
        });

        var x0 = 0,
          y0 = 0,
          on = false;
        stage.addEventListener(
          'touchstart',
          function (e) {
            if (e.touches.length !== 1) {
              on = false;
              return;
            }
            on = true;
            x0 = e.touches[0].clientX;
            y0 = e.touches[0].clientY;
          },
          { passive: true }
        );
        stage.addEventListener(
          'touchend',
          function (e) {
            if (!on) return;
            on = false;
            var t = e.changedTouches[0];
            var dx = t.clientX - x0,
              dy = t.clientY - y0;
            if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) {
              show(+stage.dataset.lcI + (dx < 0 ? 1 : -1));
            }
          },
          { passive: true }
        );
      });
    }
    function initAll() {
      document.querySelectorAll('.flagship-layer-cards').forEach(initLayerCards);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector) initLayerCards(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach(
            (el) => {
              [...el.classList]
                .filter((cl) => cl.indexOf('disclosure') === 0)
                .forEach((cl) => {
                  el.classList.remove(cl);
                  el.classList.add(`mobile-${cl}`);
                });
            },
          );
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll(
            '.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content',
          ).forEach((el) => {
            [...el.classList]
              .filter((cl) => cl.indexOf('mobile-disclosure') === 0)
              .forEach((cl) => {
                el.classList.remove(cl);
                el.classList.add(cl.substr(7));
              });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function () {
    // Look for an element with class 'related-products'
    var productRecommendationsSection = document.querySelector('.related-products');
    if (productRecommendationsSection === null) {
      return;
    }
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open('GET', productRecommendationsSection.dataset.url);
    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement('div');
        container.innerHTML = request.response;
        productRecommendationsSection.innerHTML = container.querySelector('.related-products').innerHTML;
      }
    };
    request.send();
  };
  // fetch when section reloads in editor
  document.addEventListener('shopify:section:load', function (event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
